import React, { Component } from 'react';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import { withShellContext } from 'hoc/withShellContext';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

@inject((stores) => ({
  isMobile: stores.UiStore.isMobile
}))
@observer
class ContentBasePageActions extends Component {
  static propTypes = {
    saveLabel: PropTypes.string,
    onlySave: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isMobile: PropTypes.bool,
    isMembership: PropTypes.bool,
    children: PropTypes.node,
    onSubmit: PropTypes.func,
    onSubmitAndReturn: PropTypes.func,
    cancelHandler: PropTypes.func
  };

  static defaultProps = { saveLabel: 'general.save' };

  state = {
    observer: null
  };

  render() {
    const {
      cancelHandler,
      onlySave,
      isMobile,
      children,
      onSubmit,
      onSubmitAndReturn,
      saveLabel,
      isDisabled,
      isMembership
    } = this.props;

    const fixedFooterClasses = classNames(
      '_d-flex _flex-column _flex-lg-row _align-items-center _justify-content-center _justify-content-lg-end',
      '_w-full _p-5 _bg-white _border-top _border-gray-200 content__base__page__footer',
      { '_bg-white': !isMembership },
      { '_bg-gray-100': isMembership }
    );
    const divButtonsClasses = classNames('_d-flex _justify-content-end', {
      '_w-full': isMobile
    });
    const cancelButtonClasses = classNames(
      'hot-button hot-button--tertiary hot-button--sm _text-2 _mr-4',
      { '_w-half': isMobile }
    );
    const saveButtonClasses = classNames(
      'hot-button hot-button--primary hot-button--sm _text-2',
      { '_w-half': isMobile && !onlySave },
      { 'hot-button--block': isMobile && onlySave }
    );

    return (
      <div className={fixedFooterClasses}>
        {children}

        <div className={divButtonsClasses}>
          {!onlySave && (
            <button
              type="button"
              className={cancelButtonClasses}
              data-test="c-button-cancel"
              onClick={cancelHandler}
            >
              <I18n label="general.cancel" />
            </button>
          )}

          <button
            className={saveButtonClasses}
            data-test="c-button-save"
            disabled={isDisabled}
            {...(onSubmitAndReturn && {
              type: 'button',
              onClick: onSubmitAndReturn
            })}
            {...(!onSubmitAndReturn && { onClick: onSubmit })}
          >
            <I18n label={saveLabel} />
          </button>
        </div>
      </div>
    );
  }
}

export default withShellContext(ContentBasePageActions);
